import React from "react";
import { AppRouter } from "router";
import styled from "styled-components";
import { ToastContainer } from "react-toastify";
import { BrowserRouter } from "react-router-dom";

import { root } from "@constants/navlinks";
import { Header } from "@components/organisms";
import { ScrollContainer } from "@components/moleculs";

import "./scss/main.scss";
import "react-toastify/dist/ReactToastify.css";

import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

function App() {
  return (
    <BrowserRouter basename={root}>
      <ToastContainer limit={1} />

      <AppContainer>
        <Header />

        <ScrollContainer>
          <ContentContainer>
            <AppRouter />
          </ContentContainer>
        </ScrollContainer>
      </AppContainer>
    </BrowserRouter>
  );
}

export default App;

const ContentContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;

  max-width: 1920px;
  margin: 0 auto;
  position: relative;

  padding: 20px;
  flex-grow: 45;
  height: 100%;
`;

const AppContainer = styled.div`
  width: 100%;
  height: 100vh;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  position: relative;
`;
